import React from 'react';
import { useTranslation } from 'react-i18next';
import { CancelModalContentProps } from './types';
import Button from "@sharedComponents/Button";
import {ButtonType} from '@sharedComponents/Button/types'
import './Scss/cancel-modal-content.scss'

const CancelModalContent = (props: CancelModalContentProps) => {
    const { t } = useTranslation();

    return (
        <div className='cancel-modal-content'>
            <h3>{t('modal.areyousure')}</h3>
            <p>{t('message.savewarning')}</p>
            <div className='cancel-modal-content__button'>
                <Button
                    type={ButtonType.PRIMARY}
                    text={t('button.nostay')}
                    onClick={props.onHideCancelModal}
                    className="cancel-modal-button-lg"
                />
            </div>
            <div className='cancel-modal-content__button'>
                <Button
                    type={ButtonType.SECONDARY}
                    text={t('button.yescancel')}
                    onClick={props.onConfirmCancel}
                    className="cancel-modal-button-lg"
                />
            </div>
        </div>
    );
}

export default CancelModalContent;